<template>
  <div class="stats-card">
    <h3 class="card-header"><i class="fas fa-chart-bar"></i> Statistics</h3>
    <div class="stats-content">
      <div class="stat-item">
        <div class="stat-value">{{ instructor.totalSessions || 0 }}</div>
        <div class="stat-label">Total Sessions</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">{{ instructor.totalStudents || 0 }}</div>
        <div class="stat-label">Total Students</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">{{ instructor.rating || 'N/A' }}</div>
        <div class="stat-label">Average Rating</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">{{ instructor.completionRate || '0%' }}</div>
        <div class="stat-label">Completion Rate</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstructorStats',
  props: {
    instructor: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.stats-card {
  background: white;
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
}

.card-header {
  background: #f8fafc;
  color: #1e293b;
  padding: 1rem 1.5rem;
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.card-header i {
  color: #3b82f6;
}

.stats-content {
  padding: 1.25rem 1.5rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

.stat-item {
  text-align: center;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 0.5rem;
  transition: transform 0.2s ease;
}

.stat-item:hover {
  transform: translateY(-2px);
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #3b82f6;
  margin-bottom: 0.5rem;
}

.stat-label {
  color: #64748b;
  font-size: 0.875rem;
}

@media (max-width: 640px) {
  .stats-content {
    grid-template-columns: 1fr;
  }
}
</style> 